import loadable from '@wix/yoshi-flow-editor/loadable';

export const getCollapsibleListData = loadable.lib(() =>
  import(
    /* webpackChunkName: "get-collapsible-list-faq-data" */
    '@wix/communities-blog-client-common/dist/src/services/get-collapsible-list-faq-data'
  ),
);
